import { format, formatDistanceToNowStrict } from 'date-fns';
import en from 'date-fns/locale/en-GB';

export const enum DateFormat {
  full = 'd MMMM yyyy',
  fullShortMonth = 'd MMM yyyy',
  fullWithoutDate = 'MMMM yyyy',
  fullWithoutDateUnderscored = 'MMMM_yyyy',
  numericAsc = 'dd-MM-yyyy',
  numericDesc = 'yyyy-MM-dd',
  month = 'MMMM',
  shortMonthYear = 'MMM yyyy',
  day = 'd',
  hoursMinutes = 'HH:mm',
  shortMonth = 'MMM',
  year = 'yyyy',
  dayOfMonthWithYear = 'do MMMM yyyy',
}

export const formatDate = (value: Date | number, dateFormat: DateFormat): string =>
  format(value, dateFormat, {
    locale: en,
  });

type FormatUnit = 'second' | 'minute' | 'hour' | 'day' | 'month' | 'year';
export const formatDateDistanceToNowStrict = (date: Date | number, unit?: FormatUnit) =>
  formatDistanceToNowStrict(date, {
    unit,
    locale: en,
  });
